module.exports = __webpack_public_path__ + "static/calendarIphone.032fa6af.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/calendarIphone.png
// module id = ./src/media/calendarIphone.png
// module chunks = 2345137460201621000